<template>
<div   ><!--ini -->

  <v-row v-on:keyup.enter="loadDiapositiva('next')" 
         v-on:keyup.down="loadDiapositiva('next')" 
         v-on:keyup.up="loadDiapositiva('back')">

  <v-col cols="2" class="">
         <v-col cols="12">
          <v-btn class="mx-2 pl-1" id="view-fullscreen" fab dark x-small color="warning" ><v-icon small > fa-desktop</v-icon></v-btn>
          <v-btn class="mx-2 pl-1" id="cancel-fullscreen" fab dark x-small color="info" ><v-icon small > fa-desktop</v-icon></v-btn>
          <v-btn class="primary mt-2"  @click="volverAtras">Volver</v-btn>
    </v-col>
     <div>
  <v-container fluid>
    <v-row wrap style="max-height: 700px" class="overflow-y-auto">
      <!-- -->
      <v-alert type="warning" outlined v-if="diapositivas.length===0">
     Aún no existen diapositivas creadas.
      </v-alert>
      <v-col cols="12" v-for="(item,index) of diapositivas" :key="index">

        <v-card @click="verDiapositivaPregunta(item,index)" class="diapositiva " v-if="item.tipo==='PM' || item.tipo==='PU' || item.tipo==='PV'">
            
              
            <div class="d-flex justify-space-between" >
              <v-avatar color="indigo" size="26">
                  <span class="white--text headline">{{index+1}}</span>
              </v-avatar>
              <span class="text-center font-weight-black" style="font-size:10px">Diapositiva De Pregunta</span>
            </div>

            <v-img  src="@/assets/iconos/PU.svg" v-if="item.tipo==='PU'" class="white--text align-end imagen"></v-img>
            <v-img  src="@/assets/iconos/PM.svg" v-if="item.tipo==='PM'" class="white--text align-end imagen"></v-img>
            <v-img  src="@/assets/iconos/VF.svg" v-if="item.tipo==='PV'" class="white--text align-end imagen"></v-img>

        </v-card >
      <v-card v-else @click="verDiapositiva(item, index)" class="diapositiva">


            <div class="d-flex justify-space-between" >
              <v-avatar color="indigo" size="26">
                <span class="white--text headline">{{index+1}}</span>
              </v-avatar>
              <span v-html="item.titulo" class="text-center font-weight-black" style="font-size:10px"></span>
              
            </div>
            
            <v-img  src="@/assets/iconos/1-COL.jpg" v-if="item.tipo==='C1'" class="white--text align-end imagen"></v-img>
            <v-img  src="@/assets/iconos/2-COL.jpg" v-if="item.tipo==='C2'" class="white--text align-end imagen"></v-img>
            <v-img  src="@/assets/iconos/3-COL.jpg" v-if="item.tipo==='C3'" class="white--text align-end imagen"></v-img>
            <v-img  src="@/assets/iconos/4-COL.jpg" v-if="item.tipo==='C4'" class="white--text align-end imagen"></v-img>
      </v-card>
      </v-col>

    </v-row>
  </v-container>
</div>
    
  </v-col>
  <!-- end side -->
  <v-col cols="10" class="fondo-presentacion" v-bind:style="{ backgroundImage: image }">
    <div>
          <!-- <v-alert type="error" v-if="msj" dismissible>  {{text}}   </v-alert> -->
      <!-- -->
      <v-col cols="12" md="">
        <component :is="vistaDiapositiva"
          :presentacion="diapost" 
          :preguntas="pregunta" 
          :respuestaVerdadera="rv" 
          :respuestaUnica="ru"
          :respuestas="rm"
          :opciones="opcs"
          :validar="valid"
          @comprobar="validarRespuesta">
        </component>
      </v-col>    
      <!-- -->
</div>

  </v-col>
</v-row>

<!-- <pre>{{$data}}</pre> -->
</div><!--end -->
</template>

<script>
import VistaCol01 from '@/views/Manager/CreadorContenido/componentes/vistas/VistaCol01.vue'
import VistaCol02 from '@/views/Manager/CreadorContenido/componentes/vistas/VistaCol02.vue'
import VistaCol03 from '@/views/Manager/CreadorContenido/componentes/vistas/VistaCol03.vue'
import VistaPreg  from '@/views/Manager/CreadorContenido/componentes/vistas/VistaPre1.vue'


import axios  from "@/helpers/axios";
import {mapMutations, mapGetters, mapActions} from 'vuex';

export default {
  name: 'contenidodiapositiva',
  props:['diapositivas','dataSet'],
  
  data() {
    return {
    diapost:[],
    paramComponente:{ 'id_submodulo':22, "id_modulo": 4},
    pregunta:[],

    vistaDiapositiva:'',
    indexDiapositiva: 0,
    image:'',
    rv:false,
    ru:false,
    rm:false,
    opcs:false,
    valid:true,
    hidentemplate: true,
 
    api1:[],
    variable:-1,
    vista:false,

    tipoComponente :'',
    prueba:[],
    vef:0,
    vif:0,

    
    };

  },
 
  mounted() {
      
      this.fullsc()

  
    },

    created() {

    this.actualizarParamentro()
  
  },

  computed: {
        ...mapGetters('login', [ 'componenteEvento'])
      },


  methods: {

    ...mapActions('login',['parametroComponente'] ),
    ...mapMutations('mensajeSis', ['setEnviarMens']),


  actualizarParamentro() {
                //console.log( `parametroComponente ${JSON.stringify(this.paramComponente)}`)
                 this.parametroComponente(this.paramComponente)
            },
    /******volver atras **** */
    volverAtras(){
      this.$emit('irClases');
    },
    validarRespuesta(tipo){
      if(tipo ==='prU'){
        this.ru = true
      }else if(tipo === 'prM'){
        this.rm = true
        this.opcs = false
        this.valid = false
      }
        
    },


    ////////////////////////////////////////////
    /* ver diapositiva ****/
    async verDiapositiva(item, index){
      
      this.indexDiapositiva = index

      if(this.vif != item.id){
          this.diapost = []
          var id = item.id
          try{
            let response = await axios.get("/manager/contenido/"+id+"");
            this.prueba = response.data
            this.diapost = JSON.parse(this.prueba[0].json_contenido)
            this.rv = false
            this.ru = false
            this.verificarColumnas(item.tipo)
            this.vif = item.id
            //console.log('dipost====>>>'+JSON.stringify(this.diapost.seccion1));
          }catch(error){
            console.log(error);
          }
      }else{


          this.setEnviarMens({tipo:"W", mensaje: `Ya estás en esta diapositiva`, tiempo:null})
      }
     
    },
    async verDiapositivaPregunta(item, index){
      
      this.indexDiapositiva = index
    
      this.valid = true
      this.ru = false
      this.rm = false
      this.opcs = true
      if(this.vif != item.id){
         var id = item.id
       try{
         let response =await axios.get("/manager/contenido/preg/"+id+"");
          this.pregunta = response.data.payload;
          this.verificando(item.tipo);
          this.vif = item.id
          //console.log('pregunta====>>>'+JSON.stringify(this.pregunta));
       }catch(error){
         console.log(error)
       }
      }else{
        alert('ya estas en esta diapositiva');
      }
     
    },


    validarEventDiapositiva(event){

      if(this.diapositivas.length>0){
      
        const maxIndex =  this.diapositivas.length

        if(event == "next"){

            let indexNew = this.indexDiapositiva + 1

            if(indexNew < maxIndex){                
              return indexNew 
            }else{
              this.setEnviarMens({tipo:"W", mensaje: `Fin de Diapositivas (${maxIndex+1})`, tiempo:null})
              return false
            }
        }
        if(event == "back"){
          let indexNew = this.indexDiapositiva - 1
          if(indexNew == -1){
             this.setEnviarMens({tipo:"W", mensaje: `Ya esta en el inicio de la Diapositivas (1)`, tiempo:null}) 
             return false

          }else{
            return indexNew
          }
     
        }

        return false
      }else{
        return false
      }

    },


    loadDiapositiva(event){

        const indexNew = this.validarEventDiapositiva(event)

        if( typeof(indexNew) == 'number'){
            const datosDiapositiva = this.diapositivas[indexNew]

      
            if(datosDiapositiva.tipo === 'PM' || datosDiapositiva.tipo==='PU' || datosDiapositiva.tipo==='PV'){
   
              this.verDiapositivaPregunta(datosDiapositiva, indexNew)

            }else{
              this.verDiapositiva(datosDiapositiva,indexNew)
            }
        }

       

    }, 


    verificarColumnas(tipo){
        
        if(tipo === 'C1'){
          this.vistaDiapositiva = 'VistaCol01'
        }else if(tipo === 'C2'){
          this.vistaDiapositiva = 'VistaCol02'
        }else if(tipo === 'C3'){
          this.vistaDiapositiva = 'VistaCol03'
        }
    },
       verificando(tipo){
          if(tipo==='PU' || tipo==='PM' || tipo==='PV'){
            this.vistaDiapositiva = 'VistaPreg'
          }
       },
      
    fullsc: function(){
       
    var viewFullScreen = document.getElementById("view-fullscreen");
    if (viewFullScreen) {
        viewFullScreen.addEventListener("click", function () {
            var docElm = document.documentElement;
            if (docElm.requestFullscreen) {
                docElm.requestFullscreen();
            }
            else if (docElm.msRequestFullscreen) {
                docElm = document.body; //overwrite the element (for IE)
                docElm.msRequestFullscreen();
            }
            else if (docElm.mozRequestFullScreen) {
                docElm.mozRequestFullScreen();
            }
            else if (docElm.webkitRequestFullScreen) {
                docElm.webkitRequestFullScreen();
            }
        }, false);
    }

    var cancelFullScreen = document.getElementById("cancel-fullscreen");
    if (cancelFullScreen) {
        cancelFullScreen.addEventListener("click", function () {
            if (document.exitFullscreen) {
                document.exitFullscreen();
            }
            else if (document.msExitFullscreen) {
                document.msExitFullscreen();
            }
            else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen();
            }
            else if (document.webkitCancelFullScreen) {
                document.webkitCancelFullScreen();
            }
        }, false);
    }
    

    var fullscreenState = document.getElementById("fullscreen-state");
    if (fullscreenState) {
        document.addEventListener("fullscreenchange", function () {
            fullscreenState.innerHTML = (document.fullscreenElement)? "" : "not ";
        }, false);
        
        document.addEventListener("msfullscreenchange", function () {
            fullscreenState.innerHTML = (document.msFullscreenElement)? "" : "not ";
        }, false);
        
        document.addEventListener("mozfullscreenchange", function () {
            fullscreenState.innerHTML = (document.mozFullScreen)? "" : "not ";
        }, false);
        
        document.addEventListener("webkitfullscreenchange", function () {
            fullscreenState.innerHTML = (document.webkitIsFullScreen)? "" : "not ";
        }, false);
    }    

    },

},

  components: {
    VistaCol01,
    VistaCol02,
    VistaCol03,
    VistaPreg 

  }
}
    

</script>


<style>

/* Maquetacion */

.a{
    background-color: brown;
}
.b{
    background-color: rgb(15, 221, 170);
}
.c{
    background-color: blueviolet;
}
.d{
    background-color: rgb(3, 86, 124);
}


.fondo-presentacion{
    margin: 0;
    height: auto;
    background-position: center; /* Center the image */
    background-repeat: no-repeat; /* Do not repeat the image */
    background-size: cover; 
}
.diapositiva{
  position: relative;
  width: 200px;
  transition: width 4s;
  cursor: pointer;
}



</style>